import { ValueWithUnit } from '@repo/shared/components'
import { AspectRatio, Col, Icon, Row, Typography } from '@repo/ui/components'
import type { Asset } from './wallet.types'
import { Link } from '@repo/shared/i18n/navigation'
import Image from 'next/image'

export interface WalletCardItemProps {
  asset: Asset
}

export const WalletCardItem = ({ asset }: WalletCardItemProps) => {
  return (
    <Link
      href={asset.href || ''}
      className=' border-b border-neutral-surface-5 py-md'
      prefetch='auto'
    >
      <Row className='gap-md'>
        <div className='w-3xl'>
          <AspectRatio className=' aspect-1/1'>
            {asset.unit === 'MALEK' ? (
              <Image
                src={`/images/club-gem.svg`}
                alt={asset.unit}
                width={20}
                height={20}
              />
            ) : (
              <Icon
                name={asset.icon || 'WalletLine'}
                size='sm'
                color='fill-current'
              />
            )}
          </AspectRatio>
        </div>

        <div className='gap-xs flex  items-end justify-between w-full flex-row'>
          <Col className='gap-xs'>
            {asset.title && (
              <Typography
                size='xs'
                weight='bold'
                color='text-neutral-surface-100'
              >
                {asset.title}
              </Typography>
            )}
            {asset.unit !== 'IRR' && (
              <Row className='gap-xs'>
                <Typography size='2xs' color='text-neutral-surface-60'>
                  {asset.unit === 'MALEK' ? 'SQ²' : asset.unit}
                </Typography>
              </Row>
            )}
          </Col>
          <Col className='justify-end gap-md items-end'>
            {/* wallet: IRR and MALEK */}
            {asset.unit !== 'IRR' && (
              <ValueWithUnit
                value={asset.assetAmount || 0}
                unit={asset.type === 'asset' ? 'crypto' : asset.unit}
                scale={asset.scale}
              />
            )}
            <Row className='gap-2xs w-fit'>
              <ValueWithUnit
                value={
                  asset.unit === 'IRR'
                    ? asset.assetAmount
                    : asset.unit === 'MALEK'
                      ? (asset.amount as number) / 10
                      : asset.amount
                }
                unit='TMN'
                valueWeight='regular'
                valueSize='xs'
                scale={asset.scale}
              />
            </Row>
          </Col>
        </div>
      </Row>
    </Link>
  )
}
